
    import './styles.scoped.css';
    export default {
  "root": "_root_20xue_3"
};
  